import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Tooltip } from '@mui/material';
import DataTable from 'react-data-table-component';

const tableCustomStyles = {
  headCells: {
    style: {
      fontSize: '0.78rem',
      fontWeight: 700,
      textTransform: 'uppercase' as const,
      color: '#495057',
      backgroundColor: '#f8f9fa',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
  cells: {
    style: {
      fontSize: '0.875rem',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
  rows: {
    style: {
      minHeight: '44px',
      '&:hover': { backgroundColor: '#f5f8ff' },
    },
  },
};

type ProductsColumnsProps = {
  t: (key: string) => string;
  data: any[];
  showEditAction?: boolean;
  onEditProduct?: (product: any, originalIndex: number) => void;
};

const ProductsColumns = ({ t, data, showEditAction = false, onEditProduct }: ProductsColumnsProps) => {
  const columns: any[] = [
    {
      name: t('production_cycle.nature'),
      selector: (row) => row.nature,
      sortable: true,
      center: true,
      grow: 1.2,
    },
    {
      name: t('production_cycle.description'),
      selector: (row) => row.description,
      sortable: true,
      center: true,
      grow: 2,
    },
    {
      name: t('production_cycle.quantity'),
      selector: (row) => row.quantitySort,
      format: (row) => row.quantityDisplay,
      sortable: true,
      center: true,
      grow: 1,
    },
    {
      name: t('production_cycle.amount'),
      selector: (row) => row.amountValue,
      format: (row) => row.amount,
      sortable: true,
      right: true,
      grow: 1,
    },
    {
      name: t('production_cycle.currency'),
      selector: (row) => row.currency,
      sortable: true,
      center: true,
      grow: 1,
    },
  ];

  if (showEditAction) {
    columns.push({
      id: 'Action',
      name: t('actions'),
      cell: (row) => (
        <Tooltip title={t('edit')}>
          <EditOutlinedIcon
            onClick={() => onEditProduct?.(row.originalProduct, row.originalIndex)}
            sx={{
              cursor: 'pointer',
              color: '#2196f3',
              fontSize: 22,
              '&:hover': { color: '#1976d2' },
            }}
          />
        </Tooltip>
      ),
      sortable: false,
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    });
  }

  return <DataTable columns={columns} data={data} customStyles={tableCustomStyles} />;
};

export default ProductsColumns;
